export enum QueryKey {
  createCoupon = 'createCoupon',
  getOffers = 'getOffers',
  getCoupons = 'getCoupons',
  getCoupon = 'getCoupon',
  deleteCoupon = 'deleteCoupon',
  refundCoupon = 'refundCoupon',
  downloadCouponsXlsx = 'downloadCouponsXlsx',
}
